import { Fragment, createContext, useState, useCallback, useContext } from 'react';

interface Props {
  children: React.ReactNode;
}

const AppReloadContext = createContext<(() => void) | null>(null);

export const AppReloadProvider = ({ children }: Props) => {
  const [key, setKey] = useState(false);

  const appReload = useCallback(() => {
    setKey((prevKey) => !prevKey);
  }, []);

  return (
    <AppReloadContext.Provider value={appReload}>
      <Fragment key={String(key)}>{children}</Fragment>
    </AppReloadContext.Provider>
  );
};

export const useAppReload = () => {
  const appReload = useContext(AppReloadContext);

  if (!appReload) {
    throw new Error('useAppReload must be used within a AppReloadProvider');
  }

  return appReload;
};
